import type { CommonSVGProps } from './helpers';

export const EmptyCard = (props: CommonSVGProps) => (
  <svg fill="none" viewBox="0 0 148 70" {...props}>
    <rect fill="#D9D9D9" height={70} rx={8} width={148} />
    <rect fill="#fff" height={11} rx={5.5} width={34} x={6} y={52} />
    <rect fill="#E9E9E9" height={5} rx={2.5} width={136} x={6} y={9} />
    <rect fill="#E9E9E9" height={5} rx={2.5} width={66} x={6} y={18} />
  </svg>
);
